import { Helmet } from 'react-helmet';
import FaviconLinks from '../components/common/FaviconLinks';
import AdminPanel from '../components/admin/AdminPanel';
import BrandLogo from '../components/common/BrandLogo';

export default function AdminPage() {
  return (
    <>
      <Helmet>
        <title>Admin Panel — Kanus Digital</title>
        <FaviconLinks />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
      </Helmet>
      <div style={{ minHeight: '100vh', background: '#0f0f0f' }}>
        <div
          style={{
            padding: '20px 40px',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <a href="/" style={{ textDecoration: 'none' }}>
            <BrandLogo variant="admin" showAdmin />
          </a>
          <a href="/" className="p-color fz-14">← Siteye Dön</a>
        </div>
        <AdminPanel />
      </div>
    </>
  );
}
